import {
  ASSIGNMENT_MODAL_BUTTON_ABLE,
  ASSIGNMENT_MODAL_BUTTON_DISABLE,
  ASSIGNMENT_MODAL_CLOSE,
  ASSIGNMENT_MODAL_OPEN,
  ASSIGNMENT_MODAL_RESTAURANT_PRODUCTS_CLOSE,
  ASSIGNMENT_MODAL_RESTAURANT_PRODUCTS_OPEN
} from "../action-types/utils-types";

export const initialState = {
  openAssignment: false,
  openAssignmentRestaurantsProducts: false,
  disableAssignmentButton: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ASSIGNMENT_MODAL_OPEN:
      return {
        ...state,
        openAssignment: true,
      };
    case ASSIGNMENT_MODAL_CLOSE:
      return {
        ...state,
        openAssignment: false,
      };
    case ASSIGNMENT_MODAL_RESTAURANT_PRODUCTS_OPEN:
      return {
        ...state,
        openAssignmentRestaurantsProducts: true,
      };
    case ASSIGNMENT_MODAL_RESTAURANT_PRODUCTS_CLOSE:
      return {
        ...state,
        openAssignmentRestaurantsProducts: false,
      };
    case ASSIGNMENT_MODAL_BUTTON_ABLE:
      return {
        ...state,
        disableAssignmentButton: false,
      };
    case ASSIGNMENT_MODAL_BUTTON_DISABLE:
      return {
        ...state,
        disableAssignmentButton: true,
      };
    default:
      return state;
  }
}
